import React from 'react';
import PropTypes from 'prop-types';

import { faFileInvoiceDollar } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { Button } from 'components/ui/button';
import { Empty } from '@buildoutinc/blueprint-react/ui/Empty';

export default function VoucherEmptyState({ onClick }) {
  return (
    <Empty className="bg-white">
      <Empty.Media>
        <FontAwesomeIcon icon={faFileInvoiceDollar} />
      </Empty.Media>
      <Empty.Title>This deal does not have a voucher</Empty.Title>
      <Empty.Content>Create a draft voucher to get started</Empty.Content>
      <Empty.Actions>
        <Button label="Create Voucher" onClick={onClick} />
      </Empty.Actions>
    </Empty>
  );
}

VoucherEmptyState.propTypes = {
  onClick: PropTypes.func,
};
